import { C as Cart } from './cart-BA5kDYZV.js';
import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class CartItems extends HTMLElement {
  unsubscribers = [];

  static {
    Cart.sections.push('fetch-line-items');
    Cart.sections.push('fetch-line-items-cart-drawer');
  }

  connectedCallback() {
    this.sendAnalytics();
    ['cart:add', 'cart:change'].forEach((event) =>
      this.unsubscribers.push(
        Pubsub.subscribe(event, ({ sections }) => this.renderSections(sections))
      )
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Render the sections.
   * @param {Object} sections - The sections to render.
   */
  renderSections(sections) {
    const isInDrawer = this.closest('#cart-drawer') !== null;
    const sectionName = isInDrawer ? 'fetch-line-items-cart-drawer' : 'fetch-line-items';

    const html = new DOMParser().parseFromString(sections[sectionName], 'text/html');
    const target = html.querySelector('line-items');
    this.innerHTML = target.innerHTML;
  }

  sendAnalytics() {
    const productsJson = [...this.querySelectorAll('[data-product-json]')].map(({ textContent }) =>
      JSON.parse(textContent)
    );

    Shopify.analytics.publish('karl:product_variants', {
      productVariants: productsJson,
    });
  }
}

customElements.define('line-items', CartItems);
